import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/New-Jersey.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Fostering Digital Excellence in Web Design and Development for New
              Jersey
            </h2>
            <p>
              TekRevol stands as a prominent web development company in New
              Jersey, dedicated to strengthening your brand through
              cutting-edge, responsive web design that seamlessly adapts to
              various device types, including laptops, smartphones, and tablets.
            </p>
            <p>
              Our primary focus is on crafting distinctive digital products that
              not only enhance your brand's image but also deliver top-notch,
              sustainable code. Additionally, we prioritize the scalability of
              your website, ensuring that it can be extended and improved
              cost-effectively over time without the need for a complete
              redesign.{" "}
            </p>
            <p>
              What sets TekRevol apart is our unique blend of business acumen,
              design prowess, and technical expertise. Our exceptional results
              are achieved through attentive client collaboration, the creation
              of functional and aesthetically pleasing designs, and the
              meticulous selection of the most appropriate tools and
              technologies for each project.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
